import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { AxiosError } from "axios";

export interface UserOrgao {
    id: number;
    nome: string;
    sigla: string;
    perfil: string;
}

export interface UserOrgaosResponse {
    user_orgaos: UserOrgao[];
}

export interface SwitchOrgaoResponse {
    message: string;
    orgao: UserOrgao;
}

export function useUserOrgaos() {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<UserOrgaosResponse, AxiosError<{ detail: string }>>({
        retry: false,
        enabled: !!token,
        queryKey: ['user-orgaos'],
        queryFn: async () => {
            const response = await apisiseci.get<UserOrgaosResponse>(
                `/profile-management/user-orgaos/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}

export function useSwitchOrgao() {
    const token = localStorage.getItem("gov_access_token_sso");
    const queryClient = useQueryClient();

    return useMutation<SwitchOrgaoResponse, AxiosError<{ detail: string }>, number>({
        mutationFn: async (orgaoId: number) => {
            const response = await apisiseci.post<SwitchOrgaoResponse>(
                `/profile-management/switch-orgao/`,
                { orgao_id: orgaoId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user-orgaos'] });
            queryClient.invalidateQueries({ queryKey: ['admin-user'] });
            queryClient.invalidateQueries({ queryKey: ['user'] });
        },
    });
}
